import { z } from 'zod'

export const groupExpenseSplitResponseSchema = z.object({
  id: z.string().guid(),
  expenseId: z.string().guid(),
  groupId: z.string().guid(),
  userId: z.string().guid(),
  userName: z.string().nullable(),
  sharePercentage: z.number(),
  categoryId: z.string().guid().nullable(),
  createdAt: z.string(),
})

export type GroupExpenseSplitResponseDto = z.infer<typeof groupExpenseSplitResponseSchema>
